import { Action } from '@ngrx/store';
import { FeedCard } from '@vestiaire/api-sdk-angular';

export interface IFeedState {
  cards: FeedCard[];
  users: any;
}

/* ******************** */
/**   FEED SAVE STATE  **/
/* ******************** */

export const SET_FEED_STATE = '[Feed] Set Feed State';

export class SetFeedState implements Action {
  readonly type = SET_FEED_STATE;
  constructor(public payload: any) {}
}

/* ******************** */
/**  FEED FOLLOWS SYNC **/
/* ******************** */

export const SET_USER_FOLLOW = '[Feed] New Follow';

export class SetUserFollow implements Action {
  readonly type = SET_USER_FOLLOW;
  constructor(public payload: any) {}
}

export const SET_USER_UNFOLLOW = '[Feed] UnFollow';

export class SetUserUnfollow implements Action {
  readonly type = SET_USER_UNFOLLOW;
  constructor(public payload: any) {}
}

/* ******************** */
/** FEED PRODUCTS SYNC **/
/* ******************** */

export const SET_PRODUCT_LIKE = '[Feed] New Like';

export class SetProductLike implements Action {
  readonly type = SET_PRODUCT_LIKE;
  constructor(public payload: any) {}
}

export const SET_PRODUCT_UNLIKE = '[Feed] Remove Like';

export class SetProductUnlike implements Action {
  readonly type = SET_PRODUCT_UNLIKE;
  constructor(public payload: any) {}
}

export type FeedActions = SetFeedState | SetUserFollow | SetUserUnfollow | SetProductLike | SetProductUnlike;
